import React from 'react';
import Link from 'next/link';
import {
  Configure,
  Index,
  useInstantSearch,
  useHits
} from 'react-instantsearch';
import IconTrendUp from 'assets/icons/ic-trend-up-01.svg';
import locationStore from 'stores/LocationStore';
import { ALGOLIA_INDEX_NAME_QUERY_SUGGESTIONS } from 'constants/algolia';
import { createLinkToRedirect } from 'utils/createLinkToRedirect';

import * as styles from './AlgoliaPopularSearch.css';

type HitProps = {
  hit: {
    query: string;
  };
  hasMossColor?: boolean;
};

function Hit({ hit, hasMossColor }: HitProps) {
  const query = hit?.query;
  const userLocation = locationStore?.selectedLocation;

  const textClassName = `${styles.textQuery} ${
    hasMossColor ? styles.textQueryMoss : ''
  }`;

  const iconClassName = `${styles.iconStyle} ${
    hasMossColor ? styles.iconStyleMoss : ''
  }`;

  return (
    <Link
      href={createLinkToRedirect({
        param: `?s=${query}`,
        routeType: 'search-bar-default-filter',
        userLocation
      })}
      className={styles.ContentHit}
    >
      <IconTrendUp
        width={16}
        height={16}
        className={iconClassName}
        aria-hidden="true"
      />
      <p className={textClassName}>{`${query
        .charAt(0)
        .toUpperCase()}${query.substring(1)}`}</p>
    </Link>
  );
}

type SuggestionHit = {
  objectID: string;
  query: string;
};

function SuggestionsSection({ hasMossColor }: { hasMossColor: boolean }) {
  const { results } = useInstantSearch();
  const { items: hits } = useHits<SuggestionHit>();

  if (!results?.nbHits) return null;

  return (
    <>
      <h3 className={styles.title}>Pesquisas populares</h3>
      <ul className={styles.HitsList}>
        {hits.map((hit) => (
          <li key={hit.objectID} style={{ listStyle: 'none' }}>
            <Hit hit={hit} hasMossColor={hasMossColor} />
          </li>
        ))}
      </ul>
    </>
  );
}

export default function AlgoliaPopularSearch({
  userTokenAlgolia,
  hasMossColor
}: {
  userTokenAlgolia: string;
  hasMossColor: boolean;
}) {
  return (
    <div data-testid="search-algolia-dropdown-suggestions">
      <Index indexName={ALGOLIA_INDEX_NAME_QUERY_SUGGESTIONS}>
        <Configure hitsPerPage={5} userToken={userTokenAlgolia} />
        <SuggestionsSection hasMossColor={hasMossColor} />
      </Index>
    </div>
  );
}
